(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-catalog"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-catalog')) {
    customElements.define(
      'collection-catalog',
      class CollectionCatalog extends HTMLElement {
        connectedCallback() {
          this.searchInput = this.querySelector('[data-catalog-search]');
          this.pills = this.querySelectorAll('[data-catalog-tag]');
          this.items = this.querySelectorAll('[data-catalog-item]');
          this.count = this.querySelector('[data-catalog-count]');
          this.activeTag = '';

          this.searchInput?.addEventListener('input', () => this.filter());
          this.pills.forEach((pill) => {
            pill.addEventListener('click', () => {
              const tag = pill.getAttribute('data-catalog-tag') || '';
              this.activeTag = this.activeTag === tag ? '' : tag;
              this.pills.forEach((node) => {
                node.classList.toggle('is-active', node === pill && this.activeTag !== '');
              });
              this.filter();
            });
          });
        }

        filter() {
          const query = (this.searchInput?.value || '').trim().toLowerCase();
          let visible = 0;
          this.items.forEach((item) => {
            const title = item.getAttribute('data-title') || '';
            const tags = item.getAttribute('data-tags') || '';
            const matchesQuery = query === '' || title.includes(query);
            const matchesTag = this.activeTag === '' || tags.split(',').some((tag) => tag.trim() === this.activeTag);
            const show = matchesQuery && matchesTag;
            item.classList.toggle('is-hidden', !show);
            if (show) visible += 1;
          });
          if (this.count) {
            const total = this.items.length;
            this.count.hidden = query === '' && this.activeTag === '';
            this.count.textContent = `Showing ${visible} of ${total} results`;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
